import React, {Component} from 'react';
import './EtaStatusBar.css';

class EtaStatusBar extends Component {
    render() {
        let statusBarText;
        let statusBarClass;
        if (this.props.connectionLost) {
            statusBarText = 'De verbinding is helaas verbroken...';
            statusBarClass = 'status-bar-error';
        } else {
            switch (this.props.status) {
                case 'driving':
                    statusBarText = 'Iemand heeft een locatie met je gedeeld';
                    break;
                case 'aborted':
                    statusBarText = 'Oeps, de persoon heeft het delen stopgezet';
                    break;
                case 'closed':
                    statusBarText = 'Helaas... De persoon heeft de app afgesloten';
                    break;
                case 'arrived':
                    statusBarText = 'Hoppa! De persoon is op zijn bestemming aangekomen';
                    break;
                case 'id-error':
                    statusBarText = 'Sessie onbekend of niet meer actief';
                    statusBarClass = 'status-bar-error';
                    break;
                case 'connection-failure':
                    statusBarText = 'Er kon geen verbinding gemaakt worden met de server. Probeer het later nog eens';
                    statusBarClass = 'status-bar-error';
                    break;
                case 'no-parameter':
                    statusBarText = 'Voer het ID in in de URL hierboven';
                    break;
                default:
                    break;
            }

        }

        return (
            <div className={this.props.landscape ? 'EtaStatusBar EtaStatusBarLandscape' : 'EtaStatusBar'}>
                <div className='eta-status-wrapper'>
                    <p className={statusBarClass}>{statusBarText}</p>
                </div>
            </div>
        );
    }
}

export default EtaStatusBar;
